import Component from "../abstracts/Component";
import { doAjax } from "../utils/ajaxUtil";
import { IS_PRIVACY_PAGE } from "../utils/Environment";
import { trapFocusOnModal, removeTrapFocusOnModal } from "../utils/TrapFocus";

export default class MiniCartComponent extends Component {
  get SELECTORS() {
    return {
      main: ".js-addtocart",
      error: ".js-addtocart-notification",
      container: ".js-form-container",
      form: ".js-notify-me",
      giftcard: ".js-addtocart-giftcard",
      submitNotifyBtn: ".js-submit",
      addtowish: ".js-addremove-wishlist a",
      btnSize: ".c-s-r__size",
      miniCart: ".js-minicart",
      miniCartButton: "[data-minicart-trigger]",
      quickCart: ".l-quick-cart",
      dataQty: "[data-mcqty]",
      remove: ".js-removeitem",
      icon: ".c-m-h__actions__mini-cart .icon-box",
      mobileMinicartBtn: ".c-m-h__actions__mini-cart .icon-box"
    };
  }

  get CLASSES() {
    return {
      layerVisible: "show"
    };
  }

  constructor() {
    super();
    this.timeout = null;
    this.mainTarget = $(this.SELECTORS.main);
    this.error = $(this.SELECTORS.error);
    this.container = $(this.SELECTORS.container);
    this.form = $(this.SELECTORS.form);
    this.giftcard = $(this.SELECTORS.giftcard);
    this.submitNotifyBtn = $(this.SELECTORS.submitNotifyBtn);
    this.updateMiniCartBtn = $(this.SELECTORS.miniCart);
    this.miniCartButton = $(this.SELECTORS.miniCartButton);
    this.quickCart = $(this.SELECTORS.quickCart);
    this.icon = $(this.SELECTORS.icon);
    this.mobileMinicartBtn = $(this.SELECTORS.mobileMinicartBtn);
  }

  openMinicart() {
    clearTimeout(this.timeout);
    this.quickCart.parent().addClass(this.CLASSES.layerVisible);
    // Update ARIA attributes for accessibility
    this.updateMiniCartBtn.attr("aria-expanded", "true");
    this.miniCartButton.attr("aria-expanded", "true");
    this.quickCart.attr("aria-hidden", "false");
    this.quickCart.attr("tabindex", "0");
  }

  closeMinicart(trapFocusHandler) {
    this.quickCart.parent().removeClass(this.CLASSES.layerVisible);
    // Update ARIA attributes for accessibility
    this.updateMiniCartBtn.attr("aria-expanded", "false");
    this.miniCartButton.attr("aria-expanded", "false");
    this.quickCart.attr("aria-hidden", "true");
    this.quickCart.attr("tabindex", "-1");
    removeTrapFocusOnModal(this.quickCart[0], trapFocusHandler);
    this.miniCartButton.focus();
    this.quickCart[0].querySelectorAll("[tabindex='0']").forEach(el => {
      el.setAttribute("tabindex", "-1");
    });
  }

  selectedSize() {
    var sizeSelected = $(".c-pdp-s__item.selected").data("productCode");
    return sizeSelected;
  }

  updateMinicart() {
    let ctx = this;
    let $elem = ctx.updateMiniCartBtn;
    let $replace = ctx.quickCart;

    return doAjax({
      url: $elem.data("url"),
      dataType: "html",
      success: function(resp) {
        ctx.log("Minicart updated...");
        let response = new DOMParser().parseFromString(resp, "text/html");
        $replace.html(response.querySelector(".l-quick-cart").innerHTML);
        // update cart counter
        ctx.updateQty();
        // trigger event
        ctx.$emit(ctx.$customEvents.MINICART_EVENTS.update, {
          quick: $replace
        });
      },
      error: function(xhr) {
        console.log(xhr);
      }
    });
  }

  updateQty() {
    let qty = this.quickCart.find(".l-q-c__title").data("mcqty");
    // desktop
    if (this.updateMiniCartBtn != null) {
      this.updateMiniCartBtn.find(".icon-box__dot").attr("data-mcqty", qty);
    }
    // mobile
    if (this.mobileMinicartBtn != null) {
      this.mobileMinicartBtn.find(".icon-box__dot").html(qty);
    }
  }

  removeProduct(el) {
    let ctx = this;
    let $elem = $(el);
    let $main = $elem.closest(ctx.SELECTORS.quickCart);

    doAjax({
      url: $elem.data("href"),
      dataType: "json",
      type: "POST",
      success: function(resp) {
        let item = $elem.closest(".product-item");
        let qty = resp.count;
        let tot = resp.totalFormattedPrice;

        item.addClass(ctx.CLASSES.removing);
        setTimeout(() => {
          item.remove();
        }, 800);
        $main.find(".tot-price").text(tot);

        ctx.updateMinicart();

        if (resp.count > 0) {
          ctx.container.find(".qty-icon").text(qty);
        } else {
          /*setTimeout(() => {
            ctx.showEmptyMsg($main)
          }, 800);
          ;*/
        }
        ctx.updateMinicart();
      },
      error: function(xhr) {
        console.log(xhr);
      }
    });
  }

  bindEvents() {
    let ctx = this;

    // Remove product click event
    $("body").on("click.removeProduct", ctx.SELECTORS.remove, function() {
      ctx.removeProduct(this);
    });

    // Keyboard events for minicart button
    $(ctx.SELECTORS.miniCartButton).on("keydown", function(e) {
      let trapFocusHandler = null;
      // Enter key (13) or Space key (32)
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        if (ctx.quickCart.parent().hasClass(ctx.CLASSES.layerVisible)) {
          ctx.closeMinicart(trapFocusHandler);
        } else {
          ctx.quickCart[0].querySelectorAll("[tabindex='-1']").forEach(el => {
            el.setAttribute("tabindex", "0");
          });
          trapFocusHandler = trapFocusOnModal(ctx.quickCart[0]);
          ctx.openMinicart();
          ctx.quickCart[0].addEventListener("keydown", e => {
            if (e.key === "Escape") {
              ctx.closeMinicart(trapFocusHandler);
            }
          });
        }
      }
      // Escape key to close
      else if (
        e.which === 27 &&
        ctx.quickCart.parent().hasClass(ctx.CLASSES.layerVisible)
      ) {
        ctx.closeMinicart();
        // Return focus to the trigger button
        $(this).focus();
      }
    });

    // update cart counter
    // ctx.updateQty();

    window.addEventListener("resize", () => {
      if (this.$matchMedia(null, "lg")) {
        //this.desktopBehaviour();
        this.log("Minicart resize...");
      }
      /* else if (this.$matchMedia('lg', 'sm')) {
        this.tabletBehaviour();
      } else {
        this.mobileBehaviour()
      }*/
    });
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
    if (!IS_PRIVACY_PAGE) {
      this.updateMinicart();
    }
  }
}
